import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SmartContainer } from '../../styles/Containers'
import { Theme, setSpace } from '../../styles/Theme'
import { FormInput } from '../Forms/FormInput'

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const StyledInlineInput = styled(SmartContainer)`
    cursor: pointer;
    
    transition: all 200ms;
    border-radius: ${Theme.radius};
    
    &:hover {
       
        .controls {
            opacity: 1;
            margin-left: ${setSpace(2)};
            
        }
    }
    .controls {
        opacity: 0;
        transition: all 200ms;
        .MuiSvgIcon-root {
            width: 0.6em;
            height: 0.6em;
        }
    }
`

export const InlineTextInput = (props) => {

    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(props.value);
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');

    useEffect(() => {
        setValue(props.value)
    }, [props?.value])

    const handleSave = async () => {

        if (props.validate) {
            const result = await props.validate(value);
            if (result.error) {
                setError(true);
                setHelperText(result.error)
            } else {
                props.onChange(value)
                setIsEditing(false)
                setError(false)
                setHelperText('')
            }
        } else {
            props.onChange(value)
            setIsEditing(false)
            setError(false)
            setHelperText('')
        }

    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave()
        }
    }

    const handleBlur = () => {
        handleSave()
    }

    const handleSetEditing = () => {
        if (props?.disabled) return;
        setIsEditing(true);
    }

    return (
        <SmartContainer>
            {!isEditing && (
                <StyledInlineInput onClick={handleSetEditing} flex>
                    {props.children}
                    {!props?.disabled && (
                        <SmartContainer className="controls">
                            <EditOutlinedIcon />
                        </SmartContainer>
                    )}
                </StyledInlineInput>
            )}

            {isEditing && (
                <SmartContainer>
                    <FormInput
                        label={props.label}
                        type="text"
                        onChange={setValue}
                        value={value}
                        onKeyDown={handleKeyDown}
                        onBlur={handleBlur}
                        error={error}
                        helperText={helperText} />
                </SmartContainer>
            )}


        </SmartContainer>
    )
}